import React, { useEffect } from "react";
import AuctionListTable from "../../components/auctions/auctionListTable";
import { useDispatch, useSelector } from "react-redux";
import { uploadedAuctionListRequest } from "../../store/actions/fetchAuctionUploadedListAction";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/backButton";
import Main from "../../components/main";

const NbfcUploadedAuctionList = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const uploadedAuctionRes = useSelector(
		(state) => state.fetchAuctionUploadedListReducer
	);
	const { loading, uploadedAuctionResult } = uploadedAuctionRes;
	const loginObj = useSelector((state) => state.nbfcLoginReducer);
	const { loginResult } = loginObj;

	useEffect(() => {
		dispatch(
			uploadedAuctionListRequest({
				accessToken: loginResult?.access,
				auction_group: loginResult?.group_name,
			})
		);
	}, []);

	const viewTractors = (uplodedItemObj) => {
		navigate(`/uploadedInv/${uplodedItemObj.name}/${uplodedItemObj.id}`);
	};

    const backFn = () => {
        navigate('/create-auction')
    }

	return (
        <>
		<Main>
			<BackButton>
				<BackButton.IconTextConatiner
					onClick={() => backFn()}
					style={{ width: "120px", cursor: "pointer" }}
				>
					<BackButton.Icon
						src="../assets/arrow/arrow_left.svg"
						alt="arrow_left"
					/>
					<BackButton.Text>Back to Home</BackButton.Text>
				</BackButton.IconTextConatiner>
			</BackButton>
			<AuctionListTable
				loading={loading}
				data={uploadedAuctionResult?.data}
				itemsPerPage="10"
				viewTractors={viewTractors}
			/>
		</Main>
        </>
	);
};

export default NbfcUploadedAuctionList;
